"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const HeadingComponent = (props) => {
    var _a;
    return (react_1.default.createElement("h2", { className: props.className, title: props.noTitle ? undefined : (_a = props.children) === null || _a === void 0 ? void 0 : _a.toString(), style: props.style }, props.children));
};
const Heading = (0, styled_components_1.styled)(HeadingComponent) `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: lighter;
  color: ${({ color, theme }) => color || theme.fg};
  flex: 0 0 auto;
`;
exports.default = Heading;
//# sourceMappingURL=Heading.js.map